// extracted by mini-css-extract-plugin
export default {"addTaskGrid":"index_addTaskGrid__4YIJ8"};